import img1 from '../images/Rectangle 111.png';
import rating4stars from '../images/rating4stars.png';
import rating3stars from '../images/rating3stars.png';


const Technicians = [
  {
    id: 1,
    img: img1,
    name: 'Wahab Ibrahim',
    experience: '12 years',
    location: 'Lekki',
    stars: rating4stars,
  },
  {
    id: 2,
    img: img1,
    name: 'Tobi Ajani',
    experience: '6 years',
    location: 'Ikeja',
    stars: rating4stars,
  },
  {
    id: 3,
    img: img1,
    name: 'Chukwudi Agu',
    experience: '8 years',
    location: 'Oshodi',
    stars: rating3stars,
  },
  {
    id: 4,
    img: img1,
    name: 'Chukwuka Philip',
    experience: '4 years',
    location: 'Ajah',
    stars: rating4stars,
  },
];

export default Technicians
